<div class="percentage-selector">
  <div class="label-container">
    <span class="percentage-label">{{ label }}</span>
    <span *ngIf="required" class="required"> *</span>
  </div>

  <div class="input-container" [class.error]="error || is_input_error" [class.disabled]="disabled">
    <input
      type="number"
      class="percentage-input"
      [value]="value"
      [min]="min"
      [max]="max"
      [step]="step"
      [disabled]="disabled"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
      [placeholder]="placeholder"
    />

    <span class="percentage-symbol">%</span>
    <div class="arrow-container">
      <button
        type="button"
        class="arrow-button"
        (mousedown)="startAutoIncrement('up')"
        (mouseup)="stopAutoIncrement()"
        (mouseleave)="stopAutoIncrement()"
        (touchstart)="startAutoIncrement('up', $event)"
        (touchend)="stopAutoIncrement($event)"
        [disabled]="isMaxValue()"
      >
        <ds-icon
          icon="dropdown-arrow"
          type="info"
          [disabled]="isMaxValue()"
          width="26px"
          height="26px"
          class="img-down"
        ></ds-icon>
      </button>
      <button
        type="button"
        class="arrow-button"
        (mousedown)="startAutoIncrement('down')"
        (mouseup)="stopAutoIncrement()"
        (mouseleave)="stopAutoIncrement()"
        (touchstart)="startAutoIncrement('down', $event)"
        (touchend)="stopAutoIncrement($event)"
        [disabled]="isMinValue()"
      >
        <ds-icon icon="dropdown-arrow" type="info" [disabled]="isMinValue()" width="26px" height="26px"></ds-icon>
      </button>
    </div>
  </div>
  <span *ngIf="hintText && !is_input_error" [class.error]="error" [class.disabled]="disabled" class="hint-text">{{
    hintText
  }}</span>
  <span *ngIf="is_input_error" [class.disabled]="disabled" class="error hint-text">{{ error_input_message }}</span>
</div>
